import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import '../css/BaseElementsCSS/BaseElementsDesktop.css';
import HomeButton from './HomeButton';
import Level from './Level';
import StepInfos from './StepInfos';


function TopBar({ levelInfo, stepInfo, maxSteps}) {
    return (
        <div className="baseElementsTopBar">
            <div className='baseElementsTimerLevelStepRow'>
                <HomeButton className='baseElementsTopBarIconCol'></HomeButton>
            </div>
            <div>
                <div className='baseElementsTimerLevelStepRow'>
                    <Level levelInfo={levelInfo}/>
                    <StepInfos stepInfos={stepInfo + "/" + maxSteps}/>
                </div>
            </div>
        </div>
    );
}


export default TopBar;